import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root'
})

export class ClientService {

  public activeClients = new BehaviorSubject<any>([])
  public inActiveClients = new BehaviorSubject<any>([])

  private clientUrl = this.environment.baseUrl + 'business/api/setup/company/list';

  constructor(private http: HttpClient, public environment: EnvService) {
   
   }
  async getClientsLists(activeflag) {
    // console.log( 'Getting clients.. ', activeflag );
    const retrievedObject:any = localStorage.getItem('user');
    const data=JSON.parse(retrievedObject);
    let flag = true;
    if(activeflag==0){
      flag = false;
    }
    const body = {
      guid: data.guid,
      uid: data.id,
      active: activeflag
    }
    const clientsObserver= await this.http.post<any>(this.environment.baseUrl+'business/api/setup/company/list', body);
      
    return clientsObserver.subscribe(async data => {
        if( flag ) {
          this.activeClients.next(data);
          return this.activeClients.asObservable();
        } else {
          this.inActiveClients.next(data);
          return this.inActiveClients.asObservable();
        }
      })
  }

  async addClient(cdata){ 
    return this.http.post<any>(this.environment.baseUrl+'business/api/setup/company/add', cdata)
      .pipe(map(newClient=> { 
        if(newClient[0].active ) {
          this.activeClients.next([...this.activeClients.value, newClient[0]]);
          return this.activeClients.asObservable();
        } else {
          this.inActiveClients.next([...this.inActiveClients.value, newClient[0]]);
          return this.inActiveClients.asObservable();
        }
      }));
  }

  async updatedClient(client) {
    return this.http.put<any>(this.environment.baseUrl+'business/api/setup/company/update', client)
      .pipe(map( newClient => {

        if( client.originalStatus !== client.active ) {
          if( client.active ) {
            // remove from inactive and add to active list. 
            this.inActiveClients.value.forEach((c, index) => {
              if( c.client_id === newClient[0].client_id) { this.inActiveClients.value.splice(index, 1); }
            });
            this.activeClients.next([...this.activeClients.value, newClient[0]]);

          } else {
            // remove from active list and add to inactive list.
            this.activeClients.value.forEach((c, index) => {
              if( c.client_id === newClient[0].client_id) { this.activeClients.value.splice(index, 1); }
            });             
            this.inActiveClients.next([...this.inActiveClients.value, newClient[0]]); 
          }
        }
      }));
  }
  async getAssigneesList(adata) {

    return await this.http.post<any>(this.environment.baseUrl + 'business/api/setup/company/assignees', adata)
      .pipe(map(data => {
        return data;
      }));
  }
}
